import styled, { css } from 'styled-components';

interface ContainerProps {
  color?: 'green' | 'white' | 'transparent'
}

const buttonTypesVariation = {
  green: css`
    background-color: ${ props => props.theme.colors.mainColor};
    color: ${({ theme }) => theme.colors.whiteDarker};

    &:hover {
      background-color: ${props => props.theme.colors.mainColorDarker};
    }
  `,
  white: css`
    background-color: #FFFFFF;
    color: ${({ theme }) => theme.colors.greyDarker};
    border: 1px solid #EAEAEA;
  `,
  transparent: css`
    background-color: transparent;
    color: ${({ theme }) => theme.colors.mainColorDarker};
    border: 1px solid ${({ theme }) => theme.colors.mainColorDarker};
  `,
  disabled: css`
    background-color: #bababa;
    color: ${({ theme }) => theme.colors.whiteDarker};
    border: 1px solid #EAEAEA;
  `,
}

export const Container = styled.button<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 4px;
  text-align: center;
  font-weight: 600;

  margin-top: 15px;
  width: 100%;
  height: 55px;
  transition: all 0.3s ease;

  ${props => !props.disabled ? buttonTypesVariation[props.color || 'white'] : buttonTypesVariation['disabled']}
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};

  &:focus {
    text-decoration: underline;
  }

  > div {
    margin-top: 8px;
    margin-left: 15px;
    margin-right: 15px;
  }

  svg {
    margin-bottom: 3px;
  }
`;
